import React from 'react';
import {
  Button,
  IconButton,
  Link,
  NumberInput,
  Pressable,
  ScreenContainer,
  SimpleStyleScrollView,
  TextInput,
  withTheme,
} from '@draftbit/ui';
import { Image, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as AuthenticationApi from '../apis/AuthenticationApi.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import checkScreenMode from '../global-functions/checkScreenMode';
import newFormatDate from '../global-functions/newFormatDate';
import resetGlobals from '../global-functions/resetGlobals';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const SignupScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [flowType, setFlowType] = React.useState('signup');
  const [isLoading, setIsLoading] = React.useState(false);
  const [lastName, setLastName] = React.useState('');
  const [numberInputValue, setNumberInputValue] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [visibleConfirm, setVisibleConfirm] = React.useState(false);
  const [visiblePassword, setVisiblePassword] = React.useState(false);
  const [textInputValue, setTextInputValue] = React.useState('');
  const inputValid = () => {
    const expr =
      /^([\w-\.]+)@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/;
    const passwordExpr = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;

    let foundError = false;

    if (firstName.length < 1) {
      setErrorMessage('Please enter first name');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (lastName.length < 1) {
      setErrorMessage('Please enter last name');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (phone.length < 1) {
      setErrorMessage('Please enter a phone number');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (email.length < 1) {
      setErrorMessage('Please enter your email');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!expr.test(email)) {
      setErrorMessage('Please enter a valid email');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (password.length < 1) {
      setErrorMessage('Please enter a password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!password.match(passwordExpr)) {
      setErrorMessage(
        'Password must be 8+ characters and at least 1 uppercase, 1 lowercase, 1 digit.'
      );
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmPassword.length < 1) {
      setErrorMessage('Please re-enter the password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmPassword != password) {
      setErrorMessage('Passwords do not match');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    return foundError;
  };

  const resetInputs = () => {
    setFirstName('');
    setLastName('');
    setPhone('');
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setErrorMessage('');
  };
  const authenticationSignUpPOST = AuthenticationApi.useSignUpPOST();

  return (
    <ScreenContainer hasSafeArea={false} scrollable={false}>
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <SimpleStyleScrollView
            bounces={true}
            horizontal={false}
            keyboardShouldPersistTaps={'never'}
            nestedScrollEnabled={false}
            showsHorizontalScrollIndicator={true}
            showsVerticalScrollIndicator={true}
            style={StyleSheet.applyWidth(
              {
                alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
                flex: { minWidth: Breakpoints.Laptop, value: 1 },
                gap: { minWidth: Breakpoints.Laptop, value: 20 },
                justifyContent: {
                  minWidth: Breakpoints.Laptop,
                  value: 'space-evenly',
                },
              },
              dimensions.width
            )}
          >
            {/* Logo */}
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
                  justifyContent: {
                    minWidth: Breakpoints.Laptop,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              {/* Image 2 */}
              <Image
                {...GlobalStyles.ImageStyles(theme)['Image'].props}
                resizeMode={'contain'}
                source={imageSource(Images['logocropped'])}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ImageStyles(theme)['Image'].style,
                    {
                      height: [
                        { minWidth: Breakpoints.Desktop, value: 150 },
                        { minWidth: Breakpoints.Laptop, value: 200 },
                      ],
                      width: [
                        { minWidth: Breakpoints.Desktop, value: 150 },
                        { minWidth: Breakpoints.Laptop, value: 200 },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              />
            </View>
            {/* Inputs */}
            <View
              style={StyleSheet.applyWidth(
                {
                  gap: [
                    { minWidth: Breakpoints.Desktop, value: 30 },
                    { minWidth: Breakpoints.Laptop, value: 30 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Desktop, value: '20%' },
                    { minWidth: Breakpoints.Laptop, value: '25%' },
                  ],
                },
                dimensions.width
              )}
            >
              {/* Firts Name Input */}
              <TextInput
                autoCapitalize={'none'}
                autoCorrect={true}
                changeTextDelay={500}
                onChangeText={newFirtsNameInputValue => {
                  const textInputValue = newFirtsNameInputValue;
                  try {
                    setFirstName(newFirtsNameInputValue);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                webShowOutline={true}
                {...GlobalStyles.TextInputStyles(theme)['Text Input'].props}
                autoComplete={'given-name'}
                placeholder={'First Name'}
                style={StyleSheet.applyWidth(
                  GlobalStyles.TextInputStyles(theme)['Text Input'].style,
                  dimensions.width
                )}
                value={firstName}
              />
              {/* Last Name Input */}
              <TextInput
                autoCapitalize={'none'}
                autoCorrect={true}
                changeTextDelay={500}
                onChangeText={newLastNameInputValue => {
                  const textInputValue = newLastNameInputValue;
                  try {
                    setLastName(newLastNameInputValue);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                webShowOutline={true}
                {...GlobalStyles.TextInputStyles(theme)['Text Input'].props}
                autoComplete={'family-name'}
                keyboardType={'visible-password'}
                placeholder={'Last Name'}
                secureTextEntry={false}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextInputStyles(theme)['Text Input'].style,
                    {
                      backgroundColor: {
                        minWidth: Breakpoints.Desktop,
                        value: palettes.Brand.White,
                      },
                    }
                  ),
                  dimensions.width
                )}
                value={lastName}
              />
              {/* Phone Input */}
              <NumberInput
                changeTextDelay={500}
                onChangeText={newPhoneInputValue => {
                  try {
                    setPhone(newPhoneInputValue);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                webShowOutline={true}
                {...GlobalStyles.NumberInputStyles(theme)['Number Input'].props}
                autoComplete={'tel'}
                placeholder={'Enter Phone'}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.NumberInputStyles(theme)['Number Input'].style,
                    {
                      backgroundColor: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.White,
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'OpenSans_500Medium',
                      },
                      fontSize: { minWidth: Breakpoints.Laptop, value: 16 },
                    }
                  ),
                  dimensions.width
                )}
                value={phone}
              />
              {/* Email */}
              <TextInput
                autoCapitalize={'none'}
                autoCorrect={true}
                changeTextDelay={500}
                onChangeText={newEmailValue => {
                  try {
                    setEmail(newEmailValue);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                webShowOutline={true}
                {...GlobalStyles.TextInputStyles(theme)['Text Input'].props}
                autoComplete={'email'}
                keyboardType={'visible-password'}
                placeholder={'Enter Email'}
                secureTextEntry={false}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextInputStyles(theme)['Text Input'].style,
                    {
                      backgroundColor: {
                        minWidth: Breakpoints.Desktop,
                        value: palettes.Brand.White,
                      },
                    }
                  ),
                  dimensions.width
                )}
                value={email}
              />
              <View>
                {/* Password */}
                <TextInput
                  autoCapitalize={'none'}
                  autoCorrect={true}
                  changeTextDelay={500}
                  onChangeText={newPasswordValue => {
                    try {
                      setPassword(newPasswordValue);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  webShowOutline={true}
                  {...GlobalStyles.TextInputStyles(theme)['Text Input'].props}
                  autoComplete={'new-password'}
                  keyboardType={'visible-password'}
                  placeholder={'Enter Password'}
                  secureTextEntry={!visiblePassword}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextInputStyles(theme)['Text Input'].style,
                      {
                        backgroundColor: {
                          minWidth: Breakpoints.Desktop,
                          value: palettes.Brand.White,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Laptop,
                          value: 32,
                        },
                      }
                    ),
                    dimensions.width
                  )}
                  value={password}
                />
                <IconButton
                  onPress={() => {
                    try {
                      setVisiblePassword(!visiblePassword);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  size={32}
                  color={StyleSheet.getWidthValue(
                    [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.Black,
                      },
                    ],
                    dimensions.width
                  )}
                  icon={
                    visiblePassword
                      ? 'FontAwesome/eye'
                      : 'FontAwesome/eye-slash'
                  }
                  size={StyleSheet.getWidthValue(
                    [{ minWidth: Breakpoints.Laptop, value: 24 }],
                    dimensions.width
                  )}
                  style={StyleSheet.applyWidth(
                    {
                      position: {
                        minWidth: Breakpoints.Laptop,
                        value: 'absolute',
                      },
                      right: { minWidth: Breakpoints.Laptop, value: 8 },
                      top: { minWidth: Breakpoints.Laptop, value: 6 },
                    },
                    dimensions.width
                  )}
                />
              </View>
              {/* View 2 */}
              <View>
                {/* Confirm Password */}
                <TextInput
                  autoCapitalize={'none'}
                  autoCorrect={true}
                  changeTextDelay={500}
                  onChangeText={newConfirmPasswordValue => {
                    try {
                      setConfirmPassword(newConfirmPasswordValue);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  webShowOutline={true}
                  {...GlobalStyles.TextInputStyles(theme)['Text Input'].props}
                  keyboardType={'visible-password'}
                  placeholder={'Confirm Password'}
                  secureTextEntry={!visibleConfirm}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextInputStyles(theme)['Text Input'].style,
                      {
                        backgroundColor: {
                          minWidth: Breakpoints.Desktop,
                          value: palettes.Brand.White,
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Laptop,
                          value: 32,
                        },
                      }
                    ),
                    dimensions.width
                  )}
                  value={confirmPassword}
                />
                <IconButton
                  onPress={() => {
                    try {
                      setVisibleConfirm(!visibleConfirm);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  size={32}
                  color={StyleSheet.getWidthValue(
                    [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.Black,
                      },
                    ],
                    dimensions.width
                  )}
                  icon={
                    visibleConfirm ? 'FontAwesome/eye' : 'FontAwesome/eye-slash'
                  }
                  size={StyleSheet.getWidthValue(
                    [{ minWidth: Breakpoints.Laptop, value: 24 }],
                    dimensions.width
                  )}
                  style={StyleSheet.applyWidth(
                    {
                      position: {
                        minWidth: Breakpoints.Laptop,
                        value: 'absolute',
                      },
                      right: { minWidth: Breakpoints.Laptop, value: 8 },
                      top: { minWidth: Breakpoints.Laptop, value: 6 },
                    },
                    dimensions.width
                  )}
                />
              </View>
            </View>
            {/* Buttons */}
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
                  width: { minWidth: Breakpoints.Laptop, value: '100%' },
                },
                dimensions.width
              )}
            >
              {/* Error Message */}
              <>
                {!errorMessage ? null : (
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        {
                          color: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Red'],
                          },
                          fontFamily: {
                            minWidth: Breakpoints.Laptop,
                            value: 'OpenSans_400Regular',
                          },
                          fontSize: { minWidth: Breakpoints.Laptop, value: 14 },
                          marginBottom: {
                            minWidth: Breakpoints.Laptop,
                            value: 10,
                          },
                          paddingBottom: [
                            { minWidth: Breakpoints.Desktop, value: 4 },
                            { minWidth: Breakpoints.Laptop, value: 4 },
                          ],
                          paddingTop: {
                            minWidth: Breakpoints.Laptop,
                            value: 4,
                          },
                          textAlign: {
                            minWidth: Breakpoints.Laptop,
                            value: 'center',
                          },
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {errorMessage}
                  </Text>
                )}
              </>
              {/* Submit */}
              <Button
                accessible={true}
                iconPosition={'left'}
                onPress={() => {
                  const handler = async () => {
                    try {
                      if (inputValid()) {
                        return;
                      }
                      setErrorMessage('');
                      setIsLoading(true);
                      const signupResponse = (
                        await authenticationSignUpPOST.mutateAsync({
                          email: email,
                          first_name: firstName,
                          last_name: lastName,
                          password: password,
                          phone: phone,
                        })
                      )?.json;
                      if (signupResponse?.authToken) {
                        resetInputs();
                        resetGlobals(Variables, setGlobalVariableValue);
                        setGlobalVariableValue({
                          key: 'STARTING_DATE',
                          value: newFormatDate(new Date(), 'get'),
                        });
                        setGlobalVariableValue({
                          key: 'AUTH_TOKEN',
                          value: 'Bearer ' + signupResponse?.authToken,
                        });
                        navigation.navigate('AccountVerificationScreen', {
                          screen_from: 'signup',
                        });
                      } else {
                        setErrorMessage(
                          'Something went wrong! Please try again!'
                        );
                      }

                      setIsLoading(false);
                    } catch (err) {
                      console.error(err);
                    }
                  };
                  handler();
                }}
                {...GlobalStyles.ButtonStyles(theme)['New Submit Button'].props}
                loading={isLoading}
                style={StyleSheet.applyWidth(
                  GlobalStyles.ButtonStyles(theme)['New Submit Button'].style,
                  dimensions.width
                )}
                title={'Submit'}
              />
              <Link
                accessible={true}
                onPress={() => {
                  try {
                    navigation.navigate('LoginScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                selectable={false}
                {...GlobalStyles.LinkStyles(theme)['New Link'].props}
                style={StyleSheet.applyWidth(
                  GlobalStyles.LinkStyles(theme)['New Link'].style,
                  dimensions.width
                )}
                title={'Back to Login'}
              />
            </View>
          </SimpleStyleScrollView>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(SignupScreen);
